import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../AbstractElements";
import { GeneralTitle, WidgetTitle } from "../../../../Constants/Constants";
import OnlineSalesCard from "./OnlineSalesCard";
import VisitorsCard from "./VisitorsCard";
import OrderOverview from "./OrderOverview";
import LearningSummary from "./LearningSummary";
import TransactionHistory from "./TransactionHistory";
import SocialWidget from "./SocialWidget";
import ProjectCreated from "./ProjectCreated";
import SaleStatistic from "./SaleStatistic";
import { Fragment } from "react/jsx-runtime";

const GeneralContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={GeneralTitle} parent={WidgetTitle} />
      <Container fluid className="general-widget">
        <Row>
          <OnlineSalesCard />
          <VisitorsCard />
          <OrderOverview />
          <LearningSummary />
          <TransactionHistory />
          <SocialWidget />
          <ProjectCreated />
          <SaleStatistic/>
        </Row>
      </Container>
    </Fragment>
  );
};

export default GeneralContainer;
